import { render } from "./cart-item.vue?vue&type=template&id=5f5ee6e6"
import script from "./cart-item.vue?vue&type=script&lang=js"
export * from "./cart-item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__